export const FILE_UPLOAD_URL = 'uploads/file-upload';
export const IMAGE_UPLOAD_URL = 'uploads/image-upload';
export const FILE_IMPORT_URL = 'uploads/excel-upload';
export const AVATAR_UPLOAD_URL = 'uploads/avatar-upload';
